import React, { createContext, useContext, type ReactNode } from 'react'
import { useContributions } from '../changelog/lib/useContributions'

type ContributionsContextState = ReturnType<typeof useContributions>

const ContributionContext = createContext<ContributionsContextState | undefined>(undefined)

export const useContributionsContext = (): ContributionsContextState => {
  const context = useContext(ContributionContext)

  if (context === undefined) {
    throw new Error('useContributionsContext must be used within a ContributionsProvider')
  }

  return context
}

type ContributionsProviderProps = {
  children: ReactNode
  pageSize?: number
}

export default function ContributionsProvider({ children, pageSize }: ContributionsProviderProps): JSX.Element {
  const value = useContributions({ pageSize })
  return <ContributionContext.Provider value={value}>{children}</ContributionContext.Provider>
}
